import { IonCardHeader } from '@ionic/react';

export const CardHeader: React.FC<{noDivider?: boolean, children: React.ReactNode}> = ({ children, noDivider }) => {
    const borderBottom = (noDivider ? undefined : '1px solid #eee');
    return (
        <IonCardHeader style={{ borderBottom, paddingTop: 8, paddingBottom: 8, marginBottom: 12 }}>
            {children}
        </IonCardHeader>
    );
};
